import dataStore from "../../../../../../data/data";

const Mouth = async (target) => {
    const data = dataStore.getState();
    const facemesh =data.mediaprocessing[target].face.facemesh;

    if (!facemesh) return;

    const indices = [880,881,882,883,884,885,886,887,888,889,890,891,892,893,894,895,896,897];

    facemesh.traverse((child) => {
        if (!child.isMesh) return;

        const geometry = child.geometry;
        const clonedGeometry = geometry.clone();
        const indexArray = clonedGeometry.index.array;
        const newIndices = [];
        const faceCount = indexArray.length / 3;

        for (let faceIndex = 0; faceIndex < faceCount; faceIndex++) {
            if (indices.includes(faceIndex)) {
                continue;
            }

            const i = faceIndex * 3;

            newIndices.push(
                indexArray[i],
                indexArray[i + 1],
                indexArray[i + 2]
            );
        }

        clonedGeometry.setIndex(newIndices);
        clonedGeometry.computeVertexNormals();

        child.geometry.dispose();
        child.geometry = clonedGeometry;
    });

    dataStore.setState((_data) => ({
        ..._data,
        mediaprocessing: {
            ..._data.mediaprocessing,
            [target]: {
                ..._data.mediaprocessing[target],
                face: {
                    ..._data.mediaprocessing[target].face,
                    facemesh: facemesh
                }
            }
        }
    }));
};

export default Mouth;